<lvr-heading>{{ 'network_contact.create.title' | transloco }}</lvr-heading>

<form
	class="form-container"
	[formGroup]="form"
	lvrAutoSave="contact"
	[entityId]="draftId()"
	[autoLoad]="false"
	autocomplete="on"
>
	<section class="form-grid">
		<!-- Stattgefunden am -->
		@let contactedAtCtrl = form.controls.contactedAt;
		<lvr-field [label]="'base.field.contacted_at' | transloco | appendAsterisk">
			<mat-form-field
				lvrInput
				[lvrError]="
					hasError(
						contactedAtCtrl,
						'matDatepickerParse',
						'minDateExceeded',
						'maxDateExceeded',
						'matDatepickerMin',
						'matDatepickerMax',
						'required'
					)
				"
			>
				<input
					matInput
					[matDatepicker]="picker"
					formControlName="contactedAt"
					placeholder="09.10.2025"
					[max]="maxDate()"
					[min]="minDate()"
					[errorStateMatcher]="matcher"
				/>
				@if (hasError(contactedAtCtrl, 'matDatepickerParse')) {
					<mat-error>{{ 'base.form.error.date_format_invalid' | transloco: { format: dateFormatHint } }}</mat-error>
				} @else if (hasError(contactedAtCtrl, 'matDatepickerMin', 'minDateExceeded')) {
					<mat-error>{{
						'base.form.error.date_min_error' | transloco: { minDate: (minDate() | date: dateDisplayFormat) }
					}}</mat-error>
				} @else if (hasError(contactedAtCtrl, 'matDatepickerMax', 'maxDateExceeded')) {
					<mat-error>{{ 'base.form.error.date_max_error' | transloco }}</mat-error>
				} @else if (hasError(contactedAtCtrl, 'required')) {
					<mat-error>{{ 'base.form.error.contacted_at_required' | transloco }}</mat-error>
				} @else {
					<mat-hint>{{ dateFormatHint }}</mat-hint>
				}
				<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
				<mat-datepicker #picker></mat-datepicker>
			</mat-form-field>
		</lvr-field>

		<!-- Kontaktart -->
		@let contactTypeCtrl = form.controls.contactType;
		<lvr-field [label]="'base.field.contact_type' | transloco | appendAsterisk">
			<mat-form-field
				lvrInput
				[attr.aria-label]="'base.field.contact_type' | transloco"
				[lvrError]="hasError(contactTypeCtrl, 'required')"
			>
				<mat-select
					formControlName="contactType"
					[placeholder]="'base.field.select_please' | transloco"
					aria-required="true"
					[compareWith]="compareById"
				>
					@for (type of contactTypes(); track type.id) {
						<mat-option [value]="type">
							{{ type.remark }}
						</mat-option>
					}
				</mat-select>
				@if (hasError(contactTypeCtrl, 'required')) {
					<mat-error>{{ 'base.form.error.contact_type_required' | transloco }}</mat-error>
				}
			</mat-form-field>
		</lvr-field>
	</section>

	<section class="form-grid">
		<!-- Remark -->
		<lvr-field [label]="'base.field.remark' | transloco" style="margin-top: 0">
			<mat-form-field lvrInput>
				<textarea
					matInput
					formControlName="remark"
					[placeholder]="'base.field.remark_placeholder' | transloco"
					class="taller-textarea"
					[maxlength]="remarkCtrlMaxLength"
				></textarea>
				@let remarkCtrl = form.get('remark');
				<mat-hint>{{
					'base.form.hint.max_length' | transloco: { actual: remarkCtrl?.value?.length || 0, max: remarkCtrlMaxLength }
				}}</mat-hint>
			</mat-form-field>
		</lvr-field>

		<div>
			<!-- Keyword -->
			@let keywordCtrl = form.controls.keyword;
			<lvr-field [label]="'base.field.keyword' | transloco | appendAsterisk">
				<mat-form-field lvrInput [lvrError]="hasError(keywordCtrl, 'required')">
					<input
						matInput
						formControlName="keyword"
						placeholder="Erstkontakt, Folgekontakt, Beratung, ..."
						[maxlength]="keywordCtrlMaxLength"
					/>
					@if (hasError(keywordCtrl, 'required')) {
						<mat-error>{{ 'base.form.error.keyword_required' | transloco }}</mat-error>
					} @else {
						<mat-hint>{{
							'base.form.hint.max_length'
								| transloco: { actual: keywordCtrl?.value?.length || 0, max: keywordCtrlMaxLength }
						}}</mat-hint>
					}
				</mat-form-field>
			</lvr-field>

			<!-- Participants -->
			<lvr-participants
				style="padding-top: 8px"
				formControlName="participants"
				[label]="'base.field.search_participants' | transloco"
				[typeOfContact]="contactTypeCtrl?.value"
				[subject]="keywordCtrl?.value"
				[body]="form.controls.remark.value"
				[showClientToggle]="false"
			></lvr-participants>
		</div>

		<!-- Documents -->
		@let documentsCtrl = form.controls.documents;
		@if (user(); as u) {
			<lvr-document-upload
				[subjectType]="subjectType"
				[maxFileCount]="maxFileCount"
				[maxFileSize]="maxFileSize"
				[hasError]="hasFileError(documentsCtrl, 'requiredFile', 'maxFiles', 'maxFileSize', 'allowedFileTypes')"
				[multiple]="true"
				formControlName="documents"
				[showIcon]="true"
				[ownerId]="u.objectId"
			/>
		}

		<!-- Confidential -->
		<span
			>{{ 'base.field.confidential' | transloco }}
			<mat-checkbox formControlName="confidential"
				>{{ 'base.common.for' | transloco }} {{ user()?.firstName }} {{ user()?.lastName }}</mat-checkbox
			>
		</span>
	</section>

	<p lvrPadding [padHorizontal]="16" [padVertical]="24">{{ 'base.form.required' | transloco }}</p>

	<lvr-default-actions
		[disableSave]="form.invalid || !canCreateContactsPermission()"
		[showLoading]="isLoading()"
		(save)="save()"
		(cancelSave)="cancel()"
	>
		<lvr-restore-actions entityType="contact" [entityId]="draftId()"></lvr-restore-actions>
	</lvr-default-actions>
</form>
